import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { ProfileContainerState } from './profile';

const initialState: ProfileContainerState = {
  default: '',
};

export const profileSlice = createSlice({
  name: SLICE_NAME,

  initialState,
  reducers: {
    setDefault: (state: any, action: PayloadAction<any>) => {
      state.default = action.payload;
    },
  },
});

export const {
  setDefault,
} = profileSlice.actions;

export default profileSlice.reducer;
